import React, { useEffect, useState } from 'react'
import Category from './Category'
import Brands from './Brands';
import Variant from './Variant';
import Summary from './Summary';
import { useDispatch, useSelector } from "react-redux";
import { productFetch } from '../../../../slices/eligibility/eligibilitySlice';
import { toast } from 'react-toastify'
import Loader from '../../../common/Loader';
import Scheme from './Scheme';
import EmiPlans from './EmiPlans';
import Addon from './Addon';
import DoSummary from './DoSummary';

const Product = () => {
  const { subStage, stage } = useSelector(state => state.eligibility)
  const { dealerCode } = useSelector(state => state.dashboard)
  const productData = useSelector(state => state?.eligibility?.data)
  const [data, setData] = useState({ product: "", brand: "", model: "", image: "", jsonData: {} })
  const dispatch = useDispatch()
  const [loader, setLoader] = useState(false);

  // Get referenceId from URL query parameters
  const urlParams = new URLSearchParams(window.location.search);
  const referenceId = urlParams.get('referenceId');

  useEffect(() => {
    let isMounted = true;


    const fetchProductData = async () => {
      if (stage === 'product' && (subStage === 'brand') &&
        referenceId &&
        dealerCode) {
        let dealer_Code = dealerCode?.split('-')[0]?.trim();
        if (isMounted) setLoader(true);
        try {
          const response = await dispatch(productFetch({
            "reference_id": referenceId,
            "dealer_code": dealer_Code,
            "type":"brand_details"
          })).unwrap();
          setLoader(false);

          if (isMounted && response?.response_code !== 'S100') {
            !response?.payload?.error &&
            toast.error(response?.response_string);
          }
        } catch (error) {
          setLoader(false); // Always set loader to false
          if (isMounted) {
            toast.error('An error occurred while fetching product data');
          }
        }

      }
    };

    fetchProductData();

    return () => {
      isMounted = false;
    };
  }, [stage, subStage, referenceId, dealerCode]);


  return (
    <>
      {loader === true ? (
        <>
          <Loader />
        </>
      ) : (
        <>
          {subStage === 'category' && <Category data={data} setData={setData} />}
          {subStage === 'brand' && <Brands data={data} setData={setData} />}
          {subStage === 'variant' && <Variant data={data} setData={setData} />}
          {subStage === 'summary' && <Summary data={data} setData={setData} />}
          {subStage === 'scheme' && <Scheme data={data} setData={setData} />}
          {subStage === 'emi_plan' && <EmiPlans data={data} setData={setData} />}
          {subStage === 'addon' && <Addon data={data} setData={setData} />}
          {subStage === 'do_summary' && <DoSummary data={data} setData={setData} />}
        </>
      )}
    </>
  )
}

export default Product;
